import { render } from "./ActivityLogComponent.vue?vue&type=template&id=5416951c"
import script from "./ActivityLogComponent.vue?vue&type=script&lang=js"
export * from "./ActivityLogComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__